import { IssueNotifications } from '../../../cimsPage/instances/issues'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: IssueNotifications,
  edit: 'D56EC524-A9C2-4FD4-B578-33946F56D8FC',
  view: '24105A23-022D-4300-B996-DA2C490D57C0',
})

export const EditIssueNotification = Edit
export const ViewIssueNotification = View

export type IssueNotificationPermission =
  | typeof EditIssueNotification
  | typeof ViewIssueNotification
